function extendAlmaGlobal(extension, namespace) {
    window.ALMA = window.ALMA || {};
    if (namespace) {
        if (!window.ALMA[namespace]) {
            window.ALMA[namespace] = {};
        }
        window.ALMA[namespace] = { ...window.ALMA[namespace], ...extension };
    }
    else {
        window.ALMA = { ...window.ALMA, ...extension };
    }
}
export default extendAlmaGlobal;
//# sourceMappingURL=almaglobal.js.map